"use client"

import { getPinnedCloseAttemptHandler } from "@/stores/use-global-dialog-store"
import { usePinnedDialogStore } from "@/stores/use-pinned-dialog-store"
import { cn } from "@ui/utils"

import { AppDialog } from "./app-dialog"

export default function PinnedDialog() {
  const { pinnedDialogs, closeDialog, fullScreenDialogId, exitFullScreen } = usePinnedDialogStore()

  return (
    <>
      {pinnedDialogs.map((dialog) => {
        const isFullScreen = fullScreenDialogId === dialog.id
        const isNote = dialog.type === "note"

        return (
          <AppDialog
            variant="custom"
            title="Pinned dialog"
            dismiss="explicit"
            key={dialog.id}
            open={true}
            // A guarded pinned dialog (task/client/contact/prospect/note) registers a close handler
            // keyed by its id, so a dirty pinned dialog still confirms before closing; others close directly.
            onOpenChange={() => (getPinnedCloseAttemptHandler(dialog.id) ?? (() => closeDialog(dialog.id)))()}
            modal={false}
            customClassName={cn(
              dialog.dialogContentClasses,
              isNote && "h-[min(48rem,calc(100vh-2rem))] max-h-[calc(100vh-2rem)] w-[calc(100vw-2rem)] overflow-hidden",
              isFullScreen &&
                "top-4! right-4! bottom-4! left-4! z-[60]! h-auto! w-auto! max-w-none! translate-x-0! rounded-lg!"
            )}
            contentProps={{
              position: "pinned",
              onEscapeKeyDown: (event) => {
                event.preventDefault()
                if (isFullScreen) exitFullScreen(dialog.id)
              },
            }}
          >
            {dialog.content}
          </AppDialog>
        )
      })}
    </>
  )
}
